export default __webpack_public_path__ + "static/media/inventory-management.a7dfd948.png";